import React, { useState, useEffect } from 'react';
// @ts-expect-error
import collectFPS from 'collect-fps';
export var AnimationControlContext = /*#__PURE__*/React.createContext({
  disableAnimations: false,
  /**
   * @deprecated v7.0.0
   */
  onStartFpsCollection: () => {},
  /**
   * @deprecated v7.0.0
   */
  onEndFpsCollection: () => {}
});
export var AnimationControlConsumer = AnimationControlContext.Consumer;
export var useAnimationControl = () => React.useContext(AnimationControlContext);
var AnimationControlProvider = _ref => {
  var {
    fpsThreshold = 30,
    disableAnimations: disableAnimationsProp = false,
    children
  } = _ref;
  var [disableAnimations, setDisableAnimations] = useState(disableAnimationsProp);
  var [endFpsCollection, setEndFpsCollection] = useState(null);
  useEffect(() => {
    setDisableAnimations(disableAnimationsProp);
  }, [disableAnimationsProp]);
  var onStartFpsCollection = () => {
    if (disableAnimations === false && endFpsCollection === null) {
      try {
        setEndFpsCollection(collectFPS());
      } catch (_unused) {
        // hello darkness my old friend
      }
    }
  };
  var onEndFpsCollection = () => {
    if (endFpsCollection !== null) {
      // @ts-expect-error
      var fps = endFpsCollection();
      setDisableAnimations(fps < fpsThreshold);
    }
  };
  return /*#__PURE__*/React.createElement(AnimationControlContext.Provider, {
    value: {
      disableAnimations,
      onStartFpsCollection,
      onEndFpsCollection
    }
  }, children);
};
AnimationControlProvider.displayName = 'AnimationControlProvider';
export { AnimationControlProvider };
//# sourceMappingURL=index.js.map